module.exports = __webpack_public_path__ + "img/hope-church-logo-colour.814a0fea.svg";